import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { useT } from "@/i18n";

export default function CodeBlock({ code, language = "json", testid = "code-block" }) {
  const t = useT();
  const [copied, setCopied] = useState(false);
  const text = typeof code === "string" ? code : JSON.stringify(code, null, 2);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(t("ai.copied"));
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="relative overflow-hidden rounded-md border border-border bg-[#0A0A0A]" data-testid={testid}>
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-1.5">
        <span className="font-mono text-[10px] uppercase tracking-widest text-white/40">{language}</span>
        <button onClick={copy} className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] text-white/60 transition-colors hover:bg-white/10 hover:text-white" data-testid={`${testid}-copy`}>
          {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}{t("ai.copy")}
        </button>
      </div>
      <pre className="max-h-80 overflow-auto p-4 font-mono text-xs leading-relaxed text-[#e4e4e7]"><code>{text}</code></pre>
    </div>
  );
}
